import React from "react";
import AppointmentCard from "./AppointmentCard";
import EmptyState from "./EmptyState";

export const Section = ({ eyebrow, title, count, items, highlight = false, onItemClick, emptyLabel }) => {
  return (
    <section className="space-y-5" data-testid={`section-${eyebrow.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#F5F5F5] mt-1">{title}</h2>
        </div>
        <div className="text-right">
          <span className="font-mono-tight text-xl text-[#D4AF37]">{String(count).padStart(2, "0")}</span>
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#8E8E93] mt-0.5">
            {count === 1 ? "Event" : "Events"}
          </p>
        </div>
      </div>
      <div className="gold-hairline w-full" />

      {items.length === 0 ? (
        <EmptyState label={emptyLabel || "Nothing here yet"} />
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {items.map((appt) => (
            <AppointmentCard
              key={appt.id}
              appt={appt}
              onClick={onItemClick}
              highlight={highlight}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default Section;
